module.exports = __webpack_public_path__ + "img/midia-social.6ad33c08.png";